<template>
    <div>
        <div class="mb-3 p-3 rounded">
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-start d-flex">
                    <h4><strong>Rutas Aprobadas</strong></h4>
                </div>
                <div class="justify-content-end d-lg-flex d-md-flex d-sm-grid">
                    <a :href="go_to_learning" class="text-decoration-underline">Ver detalles</a>
                </div>
            </div>
        </div>
        <div>
            <apexchart type="radialBar" height="300" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "datarutas",
        "urlstudentsdetail",
        "go_to_learning"
    ],
    data() {
        return {
            series: [50],
            options: {
                chart: {
                    height: 300,
                    type: 'radialBar',
                },
                series: [100],
                labels: ['Porcentaje de aprobados'],
                colors: ['#A855F7', '#3B82F6'],
            },
        }
    },
    watch: {
        datarutas(newVal, oldVal) {
            console.log(newVal);
            this.series = [newVal.finalizadas];
            //this.options.labels = [''+newVal.terminados+" / "+newVal.asignados+'']
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style></style>